export const uk = {
    'long-upload-accept-link': 'Понятно',
    'long-upload-message-addition': 'По завершении видеодополнение будет создано автоматически.',
    'long-upload-message-creative': 'По завершении видеокреатив будет создан автоматически.',
    'long-upload-message-end': 'Не закрывайте окно.',
    'long-upload-message-start': 'Видео еще обрабатывается, пожалуйста, подождите.'
};
